'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _checkmark = require('dibs-vg/dist/react/checkmark');

var _checkmark2 = _interopRequireDefault(_checkmark);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkbox = function (_React$Component) {
    (0, _inherits3.default)(Checkbox, _React$Component);

    function Checkbox(props) {
        (0, _classCallCheck3.default)(this, Checkbox);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).call(this, props));

        _this.state = {
            checked: _this.props.checked
        };

        _this._onChange = _this._onChange.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(Checkbox, [{
        key: '_onChange',
        value: function _onChange(e) {
            var onChange = this.props.onChange;

            var _ref = e && e.target,
                checked = _ref.checked;

            if (typeof checked === 'boolean') {
                this.setState({
                    checked: checked
                });

                if (onChange) {
                    onChange(checked);
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                wrapperClass = _props.wrapperClass,
                labelClass = _props.labelClass,
                name = _props.name,
                label = _props.label,
                _props$theme = _props.theme,
                theme = _props$theme === undefined ? {} : _props$theme;
            var checked = this.state.checked;

            return _react2.default.createElement(
                'div',
                { className: wrapperClass },
                _react2.default.createElement('input', {
                    id: name,
                    name: name,
                    type: 'checkbox',
                    className: theme.hiddenInput,
                    checked: checked,
                    onChange: this._onChange
                }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: name, className: theme.container },
                    _react2.default.createElement(
                        'div',
                        { className: (0, _classnames2.default)(theme.checkbox, checked ? theme.checkboxChecked : theme.checkboxUnchecked) },
                        checked ? _react2.default.createElement(_checkmark2.default, { className: theme.checkmark }) : null
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: (0, _classnames2.default)(theme.label, labelClass) },
                        label
                    )
                )
            );
        }
    }]);
    return Checkbox;
}(_react2.default.Component);

exports.default = Checkbox;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-elements/lib/Checkbox/index.js
// module id = 853
// module chunks = 4 5 8 9 14